// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.like-plus-custom-terms {
  padding: 0 var(--spacing-small);
}
.like-plus-custom-terms .paragraph {
  margin: var(--spacing-small) 0;
  text-align: justify !important;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/components/LikeMaisOnline/LikePlusCustomTerms/LikePlusCustomTerms.less"],"names":[],"mappings":"AAAA;EACE,+BAAA;AACF;AAFA;EAII,8BAAA;EAEA,8BAAA;AAAJ","sourcesContent":[".like-plus-custom-terms {\n  padding: 0 var(--spacing-small);\n\n  .paragraph {\n    margin: var(--spacing-small) 0;\n\n    text-align: justify !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
